import * as React from "react";
import { Input } from "../../shadcn/components/ui/Input";
import { Button } from "../../shadcn/components/ui/Button"; // Import Button component
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import propertySeach from "../../assets/home/proprtysearch.jpg";

export function PropertySearch() {
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [zip, setZip] = React.useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    const queryParams = new URLSearchParams();
    if (city.trim()) queryParams.set("city", city.trim());
    if (state.trim()) queryParams.set("state", state.trim());
    if (zip.trim()) queryParams.set("zip", zip.trim());

    navigate(`/property?${queryParams.toString()}`);
  };

  return (
    <div className="relative mt-10 h-full lg:h-[250px] w-full overflow-hidden rounded-xl">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${propertySeach})`,
          filter: "brightness(0.7)",
        }}
      />
      <div className="absolute inset-0 bg-purple-900/30" />
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-white">
        <h2 className="lg:mb-2 mt-5 text-2xl lg:text-3xl font-bold">
          Property Search
        </h2>
        <p className="mb-4 lg:mb-8 text-lg text-gray-200">
          Where would you like to find a place?
        </p>
        <div className="flex w-full lg:max-w-4xl h-full flex-col gap-4 sm:flex-row text-black">
          <div className="flex-1 ">
            <label
              htmlFor="city"
              className="mb-1 block text-sm text-white font-semibold"
            >
              City
            </label>
            <Input
              id="city"
              className="h-10 bg-white/90 text-gray-900 placeholder:text-gray-500 "
              placeholder="Enter City"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
          </div>
          <div className="w-full sm:w-[20rem]">
            <label
              htmlFor="state"
              className="mb-1 block text-sm text-white font-semibold"
            >
              State
            </label>
            <Input
              id="state"
              className="h-10 bg-white/90 text-gray-900 placeholder:text-gray-500"
              placeholder="Enter State"
              value={state}
              onChange={(e) => setState(e.target.value)}
            />
          </div>
          <div className="flex-1 lg:mb-0">
            <label
              htmlFor="zip"
              className="mb-1 block text-sm text-white font-semibold"
            >
              ZIP
            </label>
            <Input
              id="zip"
              className="h-10 bg-white/90 text-gray-900 placeholder:text-gray-500"
              placeholder="Enter ZIP"
              value={zip}
              onChange={(e) => setZip(e.target.value)}
            />
          </div>
          <div className="flex items-center justify-center mb-9">
            <Button
              className="h-10 bg-purple-600 hover:bg-purple-700 text-white"
              onClick={handleSearch}
            >
              Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
